<template>
  <div class="activity">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入活动标题">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div style="color:#F56C6C;">标题格式:【城市】+ 赛事名词，如【上海】xx大赛Vol.6</div>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="活动类型" prop="typeId">
                <el-select v-model="form.typeId" placeholder="活动类型" style="width:100%;" @change="changeType" :disabled="isDisabledType">
                  <el-option v-for="item in activityTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="level-row" v-if="isShowLevel">
              <el-form-item prop="levelId">
                <el-select v-model="form.levelId" placeholder="请选择级别" style="width:89%;">
                  <el-option v-for="item in activityLevelList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
                <!-- 小图标 -->
                <i class="icon" @click="openLevelModal"></i>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="主办方" prop="sponsorId" v-if="roleType==0">
            <el-select v-model="form.sponsorId" filterable placeholder="请选择主办方" style="width:100%;" @change="cardHistory">
              <el-option v-for="item in sponsorList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动地址" prop="provinceId">
                <el-select v-model="form.provinceId" filterable placeholder="请选择省" @change="changeProvince" style="width:100%;">
                  <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="cityId">
                <el-select v-model="form.cityId" filterable placeholder="请选择市" style="width:100%;">
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="address">
            <el-input v-model="form.address" placeholder="请输入详细地址" />
          </el-form-item>
          <!-- <el-form-item prop="location">
            <div style="color:#606266;">填写经纬度，可便于用户导航到目的地，可获取坐标经纬度，如：31.163120,121.46027</div>
            <el-input v-model="form.location" placeholder="请点击右侧获取精确的经纬度">
              <el-button slot="append" icon="el-input__icon el-icon-location-outline" @click="openLocation"></el-button>
            </el-input>
          </el-form-item> -->
          <el-form-item label="举行时间" prop="rangePickerTime">
            <el-date-picker v-model="form.rangePickerTime" :picker-options="pickOptions" type="daterange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :disabled="isDisabledType">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="封面图" prop="cover">
            <el-upload class="upload-demo" :action="uploadAction" :before-upload="beforeAvatarUpload" :http-request="uploadSuccessHandler" :headers="uploadHeaders">
              <el-button size="small" type="primary">上传图片</el-button>
            </el-upload>
            <div class="upload-text">用于小程序首页活动小图显示，建议尺寸183*256，不大于1MB</div>
            <!-- <el-input v-model="form.cover" type="hidden" /> -->
            <img :src="form.cover" v-if="form.cover" class="upload-image" />
          </el-form-item>

          <el-form-item label="选择舞种" prop="dances">
            <el-checkbox-group v-model="form.dances">
              <el-checkbox v-for="item of danceList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- 票务系统 -->
          <el-form-item label="是否售票">
            <el-switch v-model="isTicket" active-color="#409EFF" inactive-color="#ddd"></el-switch>
            <!-- 售票组件 -->
            
            <div v-if="isTicket">
              <!-- 赛事:赛事票务，平台不收取票务服务费。<br />
              演出活动:演出活动票务，平台收取每笔订单3%票务服务费。<br />
              大师课:大师课票务，平台收取每笔订单5%票务服务费。 -->
              赛事：赛事票务，不收取票务服务费。<br />
              演出活动：演出活动票务，不收取票务服务费。<br />
              大师课：大师课票务，不收取票务服务费。<br />
              特别提示：2021年12月31日前的所有活动，舞匣票务订单不收取服务费（微信官方收0.6%)。
            </div>
            <ticket v-if="isTicket" ref="ticket" :ticketPropsList="ticketList"></ticket>
          </el-form-item>
          <el-form-item label="允许退款" v-if="isTicket">
            <el-switch v-model="form.isRefund" active-color="#409EFF" inactive-color="#ddd" :active-value="1" :inactive-value="0" :disabled="isDisabledType"></el-switch>
            <span style="margin-left: 5px;">开启后，购买用户可在活动结束前申请退款。请注意活动一旦设置允许退款或者不允许退款，则在编辑时不允许修改</span>
          </el-form-item>
          <el-form-item label="实名购票" v-if="(idCardOpen && currentUserInfo.platform == 1) || (form.sponsorId && currentUserInfo.platform != 1 && idCardOpen)">
            <el-switch v-model="form.idCardChecked" active-color="#409EFF" inactive-color="#ddd" :active-value="1" :inactive-value="0" @change="isTipBox" :disabled="currentUserInfo.platform != 1"></el-switch>
            <span style="margin-left: 10px;">开启后，票品标签为「实名购票」，将对购票人身份证信息进行实名认证。当前认证额度为<span class="num"> {{cardHistoryNum}} </span>。<span v-if="roleType != 0">&gt;&gt; <span class="topUp" @click="topUpTipShowState = true">去充值</span> &lt;&lt;</span></span>
          </el-form-item>
          <el-form-item label="活动描述" prop="content">
            <div>温馨提示：单张图片上传不超过5MB（为了用户体验，98%主办方上传2MB以内，宽度620的海报图片，如需压缩可以使用<span class="img-zip-link" @click="openImgZip">在线压缩工具</span>）</div>
            <tinymce-editor ref="tiny" v-model="form.content" style="width:730px;"></tinymce-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onCancelHandler" style="width:100px;">取消</el-button>
            <el-button type="primary" @click="onSubmitHandler" style="width:100px;">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <level-modal ref="levelModal"></level-modal>
    <vueCropper ref="vueCropper" @success="success" v-if="vueCropperState"></vueCropper>
    <topUpTip v-if="topUpTipShowState" @topUpTipclose="topUpTipShowState = false" />
    <lackTip ref="lackTip" v-if="lackTipState" @lackTipclose="lackTipState = false" @topUp="topUp"></lackTip>
  </div>
</template>

<script>
import LevelModal from './LevelModal';
import DictService from '@/services/system/dict';
import SponsorService from '@/services/user/sponsor';
import DanceService from '@/services/activity/dance';
import AreaService from '@/services/area';
import ActivityManagementService from '@/services/activity/activity-management';
import Ticket from './Ticket/Index';
import vueCropper from '@/components/vueCropper'
import TinymceEditor from '@/components/tinymce/Index.vue';
import topUpTip from './topUpTip'
import lackTip from './lackTip'
import * as _ from 'lodash';
import { prefix } from '@/api';
import { authToken } from '@/config';
import { storage } from '@/utils';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'activity-modal',
  props: {
    rowId: {
      type: String,
      default: '',
    },
    // 角色类型,如果是0是后台管理的,1是主办方
    roleType: {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      form: {
        title: '',
        typeId: '',
        levelId: '',
        sponsorId: '',
        provinceId: '',
        cityId: '',
        address: '',
        rangePickerTime: '',
        dances: [],
        content: '',
        cover: '',
        idCardChecked: 0
        // location: '',
      },
      topUpTipShowState: false,
      vueCropperState: false,
      isShowLevel: false,
      isTicket: false, // 是否售票
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
        ],
        typeId: [
          { required: true, message: '请输入活动类型', trigger: 'blur' },
        ],
        levelId: [
          { required: true, message: '请输入活动级别', trigger: 'blur' },
        ],
        sponsorId: [
          { required: true, message: '请选择主办方', trigger: 'blur' },
        ],
        provinceId: [
          { required: true, message: '请选择省', trigger: 'blur' },
        ],
        cityId: [
          { required: true, message: '请选择市', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        // location: [
        //   { required: true, message: '请输入经纬度', trigger: 'blur' },
        // ],
        rangePickerTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' },
        ],
        cover: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
        dances: [
          { required: true, message: '请选择舞蹈', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入活动内容', trigger: 'blur' },
        ]
      },
      activityTypeList: [],
      activityLevelList: [],
      sponsorList: [],
      provinceList: [],
      cityList: [],
      danceList: [],
      uploadAction: `${prefix}/admin/file/upload_image`, // 上传文件
      uploadHeaders: {
        token: storage.getItem(authToken),
      },
      ticketList: [], //票务数据
      cardHistoryNum: 0, //剩余身份证验证次数
      lackTipState: false
    }
  },
  methods: {
    // 获取类型、级别配置信息
    async initDictData () {
      const { code, message, result } = await DictService.dictByTypeApi({ category: ['activity_type', 'activity_level'] });
      if (Object.is(code, 0)) {
        // 使用分组
        const { activity_type, activity_level } = _.groupBy(result, 'category');
        this.activityTypeList = activity_type;
        this.activityLevelList = activity_level;
      } else {
        console.log(message);
      }
    },
    // 获取全部的主办方
    async initSponsorList () {
      const { code, message, result: { data } } = await SponsorService.sponsorListApi({ pageSize: 1000 });
      if (Object.is(code, 0)) {
        this.sponsorList = data;
      } else {
        console.error('获取主办方列表失败', message);
      }
    },
    // 获取舞蹈列表
    async initDanceData () {
      const { code, message, result } = await DanceService.danceListApi({ pageSize: 100 });
      if (Object.is(code, 0)) {
        this.danceList = result.data;
      } else {
        console.error(message, '获取舞蹈列表错误');
      }
    },
    // 初始化省份
    async initArea (type, pid) {
      const { code, message, result } = await AreaService.areaByParentIdApi(pid);
      if (Object.is(code, 0)) {
        this[`${type}List`] = result;
      } else {
        console.error(`获取${type}失败`, message);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || "png" || "gif";
      const isLt2M = file.size / 1024 < 1024;
      if (!isJPG) {
        this.$message.error("上传图片只能是 jpg/jpeg/png/gif格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传文件
    uploadSuccessHandler (data) {
      const reader = new FileReader();
      reader.readAsDataURL(data.file);
      reader.onload = e => {
        let option = {
          img: e.target.result,
          autoCropWidth: 366,
          autoCropHeight: 512
        }
        this.vueCropperState = true;
        this.$nextTick(() => {
          this.$refs.vueCropper.fileHanle(option, 'logo')
        })
      }
    },
    success(data) {
      this.vueCropperState = false;
      this.form.cover = data;
    },
    // 修改省的时候
    changeProvince (ev) {
      if (ev) {
        this.initArea('city', ev);
      }
      this.form.cityId = '';
      this.cityList = [];
    },
    // 修改类型,【演出活动】和【大师课】不展示级别，只有【赛事】才有级别
    changeType (val) {
      if (Object.is(val, 3)) {
        this.isShowLevel = true;
      } else {
        this.isShowLevel = false;
      }
    },
    // 取消
    onCancelHandler () {
      this.$router.go(-1);
    },
    // 提交数据
    onSubmitHandler () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let posttTicketList = []
          if (this.isTicket) {
            const { ticketList, isValid } = await this.$refs.ticket.getAllTicketData()
            if (!isValid) {
              this.$message.error('票务数据错误');
              return false;
            } else {
              posttTicketList = ticketList;
            }
          }
          if (this.rowId) {
            const postData = {
              ...this.form, // 表单数据
              dances: this.form.dances.toString(), //舞蹈列表
              ticketList: posttTicketList, //票务数据
            }
            console.log(postData, '=====》提交数据')
            delete postData.rangePickerTime;
            const { code, message } = await ActivityManagementService.updateActivityApi(this.rowId, postData);
            if (Object.is(code, 0)) {
              this.$message.success(message);
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            } else {
              this.$message.error(message);
            }
          } else {
            const postData = {
              ...this.form, // 表单数据
              dances: this.form.dances.toString(), //舞蹈列表
              startTime: this.form.rangePickerTime[0],
              endTime: new Date(new Date(this.form.rangePickerTime[1]).getTime() + 86399000),
              ticketList: posttTicketList, //票务数据
            }
            console.log(postData, '=====》提交数据')
            delete postData.rangePickerTime;
            const { code, message } = await ActivityManagementService.addActivityApi(postData);
            if (Object.is(code, 0)) {
              this.$message.success(message);
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            } else {
              this.$message.error(message);
            }
          }
        } else {
          this.$message.error('请检查必填字段');
        }
      })
    },
    // 编辑的时候填充表单
    async fullFormVal () {
      if (this.rowId) {
        // 根据id获取活动内容
        const { code, result } = await ActivityManagementService.activityByIdApi(this.rowId);
        if (Object.is(code, 0)) {
          const { title, typeId, levelId, address, sponsorId, provinceId, cityId, content, cover, dances, startTime, endTime, location, ticketList, idCardChecked, isRefund } = result;
          // 根据省获取地址,城市反填值
          this.changeProvince(provinceId);
          this.form = {
            title,
            typeId,
            levelId,
            address,
            provinceId,
            cityId,
            content,
            sponsorId,
            cover,
            location,
            idCardChecked,
            dances: dances.split(',').map(item => Number(item)),
            rangePickerTime: [startTime, endTime],
            isRefund
          }
          // 编辑的时候如果是赛事的时候要显示级别
          if (Object.is(typeId, 3)) {
            this.isShowLevel = true;
          }
          // 根据票务返回的数据结果是否开发票务开发
          if (ticketList && ticketList.length) {
            this.isTicket = true;
            this.ticketList = ticketList;
          }
          this.cardHistory(sponsorId)
        } else {
          console.error('获取活动失败');
        }
      }
    },
    // 打开第三方地址坐标
    openLocation () {
      window.open('https://lbs.qq.com/tool/getpoint/index.html', '_blank');
    },
    openImgZip () {
      window.open('http://www.secaibi.com/tools/', '_blank');
    },
    openLevelModal () {
      this.$refs.levelModal.openModal();
    },
    cardHistory(id) {
      SponsorService.cardCount(id).then(res => {
        this.cardHistoryNum = res.result.idCheckedCount;
      })
    },
    isTipBox(e) {
      if(e == 0) return false;
      if(this.currentUserInfo.platform != 1) return false;
      SponsorService.homeInfo().then(res => {
        if(res.code == 1) {
          this.lackTipState = true;
          this.$nextTick(() => {
            this.$refs.lackTip.getText(res.message)
          })
        }
      })
    },
    topUp() {
      this.lackTipState = false;
      this.topUpTipShowState = true;
    },
    ...mapActions(['setIdCardOpen'])
  },
  mounted () {
    this.initDictData();
    // 如果是后台的时候就查询主办方列表
    if (this.roleType == 0) {
      this.initSponsorList();
    } else {
      this.cardHistory(this.sponsorId)
    }
    this.setIdCardOpen(false)
    this.initDanceData();
    this.initArea('province', '0');
    this.fullFormVal();
  },
  computed: {
    isDisabledType () {
      if (this.rowId) {
        return true;
      } else {
        return false;
      }
    },
    pickOptions () {
      if (this.rowId) {
        return {}
      } else {
        return {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      }
    },
    ...mapState({
      sponsorId: state => state.view.currentUserInfo.sponsorId,
      currentUserInfo: state => state.view.currentUserInfo,
      idCardOpen: state => state.activity.idCardOpen
    })
  },
  components: {
    TinymceEditor,
    LevelModal,
    Ticket,
    vueCropper,
    topUpTip,
    lackTip
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-list {
  display: none;
}
.describe-text {
  font-size: 15px;
  margin: 4px 0 15px;
  color: #f00;
}
.upload-text {
  font-size: 15px;
  margin-top: 5px;
  color: #606266;
}
.upload-image {
  width: 183px;
  height: 256px;
}
.img-zip-link {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
  font-weight: 800;
}
/* 单独处理级别旁边的样式 */
.level-row {
  .icon {
    width: 20px;
    height: 20px;
    display: block;
    float: right;
    margin-top: 5px;
    background-image: url('./../../../../assets/images/level_icon.png');
    background-size: 20px;
    cursor: pointer;
  }
}
.num{
  color: #f00;
  font-weight: bold;
}
.topUp{
  cursor: pointer;
  color: #409eff;
  font-weight: bolder
}
</style>
